import { Button, ComponentType, IconName } from '@gcl/react-core';
import * as React from 'react';
import './FloatingButton.scss';

export enum EFloatingButtonPosition {
  topLeft = 'top-left',
  bottomLeft = 'bottom-left',
  topRight = 'top-right',
  bottomRight = 'bottom-right',
}
interface IFloatingButtonProps {
  position?: EFloatingButtonPosition;
  onClick: () => void;
  type?: ComponentType;
  iconName?: IconName;
}

export const FloatingButton: React.FunctionComponent<IFloatingButtonProps> = ({
  position,
  onClick,
  type,
  iconName,
}: IFloatingButtonProps) => {
  const className = position ? `gcl-gems-floating-button-${position}` : undefined;

  return (
    <div className={className}>
      <Button className="gcl-gems-floating-btn" type={type} prefixIconName={iconName} onClick={onClick} />
    </div>
  );
};
